export function getResetPasswordTimerState(
    secondsLeft: number,
    isRequestSent: boolean
) {
    const showDescription = isRequestSent;

    const isButtonDisabled = secondsLeft > 0;

    const buttonText = showDescription && secondsLeft === 0
        ?   'Повторить'
        :   secondsLeft > 0
                ? `Повторить через ${secondsLeft} сек`
                : 'Восстановить'


    return { showDescription, buttonText, isButtonDisabled };
}
